const INITIAL_STATE = {
    id: "",
    name: "",
    description: "",
    screen_name: "",
    url: ""
};

export default function (state = INITIAL_STATE, action) {
    if (action.type === "SET_MODULE_DATA") {
        return {...state, ...action.payload};
    } else {
        return state;
    }
}
